import ReactToPrint from "react-to-print";
import { PrintCard } from './printCard';
import React, { useState, useEffect, useRef } from "react";
import { Button, IconButton, Tooltip } from "@mui/material";
import { AddCardIcon } from "../../../common/icons";
export const PrintWrapper = (props) => { 
    const componentRef = useRef(); 
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <Tooltip title="Generate Card"><IconButton color="primary"><AddCardIcon/></IconButton></Tooltip>}
                content={() => componentRef.current}
            />
            <div style={{ display: "none" }}><PrintCard ref={componentRef} urn={props.urn} /></div>
        </div>
    );
};
